<script>
export default {
  name: 'ArchivedOrderItem',
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <v-card class="elevation-0 py-2">
    <v-toolbar
      v-if="order.status !== 'PENDING'"
      height="36"
      dense
      flat
      color="transparent"
    >
      <!-- Seller & status info -->
      <div class="order-title d-flex flex-column">
        <h4 class="subtitle-2 font-weight-bold">
          {{ order.seller.firstName }}
        </h4>
        <span class="caption secondary--text">
          <span v-if="order.status === 'COMPLETED'">
            Delivered at
            {{ order.completedAt || order.deliverOn | moment('Do MMM, h:mm') }}
          </span>
          <span v-if="order.status === 'CANCELED'">
            Canceled at {{ order.canceledAt | moment('Do MMM, h:mm') }}
          </span>
          <span v-if="order.status === 'REFUNDED'">
            Refunded at {{ order.refundedAt | moment('Do MMM, h:mm') }}
          </span>
        </span>
      </div>
      <v-spacer />

      <!-- Order actions -->
      <div>
        <v-btn
          outlined
          rounded
          icon
          color="secondary"
          class="mr-2"
          :to="{
            name: 'ReceiptView',
            params: { id: order.id, preloaded: { order } }
          }"
        >
          <v-icon size="14">$vuetify.icons.receipt</v-icon>
        </v-btn>
        <v-btn
          outlined
          rounded
          icon
          color="secondary"
          :to="{ name: 'OrderIssueView', params: { id: order.id } }"
        >
          <v-icon size="14">$vuetify.icons.lifeRing</v-icon>
        </v-btn>
      </div>
    </v-toolbar>

    <!-- Items list -->
    <v-list>
      <v-list-item
        v-for="lineItem in order.lineItems"
        :key="lineItem.id"
        class="order-item"
      >
        <span class="flex-grow-1 secondary--text">
          {{ lineItem.product.name }}
        </span>
        <div class="secondary--text">{{ lineItem.quantity }}×</div>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<style scoped lang="sass">
.v-card
  background-color: transparent !important

.order-title
  h4, span
    line-height: 18px

.order-item
  font-size: 14px
  min-height: 30px

.v-btn
  height: 40px !important
  width: 40px !important
  &:before
    background-color: #fff !important
</style>
